<script setup lang="ts">
import YesPlusRu from '~/assets/img/yesplusmir.svg';
import './style.scss';

const props = defineProps({
    title: {
        type: String as PropType<string>,
        default: () => undefined
    }
});
</script>

<template>
    <div class="logo-title">
        <span class="logo-title__image">
            <YesPlusRu />
        </span>
        <span v-if="props?.title" class="logo-title__text">
            {{ props.title }}
        </span>
    </div>
</template>
